import newRoutes from './v2/routes';

const manageRoutes = [].concat(newRoutes);

export default manageRoutes;
